// extracted by mini-css-extract-plugin
export default {"warning-icon":"documents-upload_warning-icon__9ViNc"};